<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="250px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <!-- CADASTRO -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: #5BC1A3">
                        <div>
                          <div>
                            <v-card-title class="text-h6">
                              <v-icon left>mdi-account-plus</v-icon>
                              Check-in
                            </v-card-title>
                            <v-card-subtitle>Realize seu check-in para o culto infantil</v-card-subtitle>
                            <v-card-actions style="padding: 0px; margin: 0px 2px 0px 2px">
                              <v-col cols="12" sm="12" md="6" lg="4">
                                <v-btn height="40px" outlined block @click="dialogoLeituraQRCode = true">Realizar</v-btn>
                              </v-col>
                            </v-card-actions>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="250px">
          </a>
        </div>
      </v-container>
    </div>

    <v-dialog v-model="dialogoLeituraQRCode" persistent max-width="400px">
      <v-card>
        <v-card-title>Leitura do QR Code</v-card-title>
        <v-card-text style="padding: 0px" v-if="tipoLeitura == 'CÂMERA'">
          <qrcode-stream @decode="fazerLeituraQRCode" v-if="dialogoLeituraQRCode"></qrcode-stream>
        </v-card-text>
        <v-card-text style="padding-bottom: 0px" v-if="tipoLeitura == 'LEITOR'">
          <v-row>
            <v-col cols="12" style="text-align: center">
              <v-icon size="100">mdi-qrcode-scan</v-icon>
              <p style="margin: 10px 0px 0px 0px; font-size: 17px">Aproxime o QR Code do leitor</p>
            </v-col>
            <v-col cols="12" style="position: absolute; left: -99999px;">
              <v-text-field v-model="membroTurmaId" id="campoCaptura" @keydown.enter="realizaCheckin" @blur="focaCampo"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialogoLeituraQRCode = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoImprimirNovamente" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <p style="margin: 0px; color: orange"><b>ATENÇÃO</b></p>
        </v-card-title>
        <v-card-text>
          <p style="margin: 0px">Check-in já realizado anteriormente para a inscrição informada. Deseja imprimir a etiqueta novamente?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="green" @click="imprimir(); dialogoImprimirNovamente = false">Sim</v-btn>
          <v-btn text color="red" @click="dialogoImprimirNovamente = false">Não</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoTipoLeitura" persistent max-width="400px">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-btn block color="primary" @click="configuraTipoLeitura('CÂMERA')">
                <v-icon left>mdi-camera</v-icon>Usar câmera
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn block color="#15AAF4" dark @click="configuraTipoLeitura('LEITOR')">
                <v-icon left>mdi-qrcode</v-icon>Usar leitor
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container v-show="false">
      <v-row id="printInscricao" dense style="padding: 0px 20px 0px 20px">
        <v-col cols="9">
          <p style="margin: 0px; font-size: 30px; font-weight: bold">{{ impressao.nome }}</p>
        </v-col>
        <v-col cols="3" style="text-align: right">
          <p style="margin: 0px; font-size: 30px; font-weight: bold">{{ impressao.idade }}</p>
        </v-col>
        <v-col cols="12" style="padding: 0px">
          <p style="margin: 0px; font-size: 20px">{{ impressao.sobrenome }}</p>
        </v-col>
        <v-col cols="6" style="text-align: center">
          <p style="margin: 0px; font-size: 14px">{{ impressao.nomePai }}</p>
          <p style="margin: 0px; font-size: 14px">{{ impressao.telefonePai }}</p>
        </v-col>
        <v-col cols="6" style="text-align: center">
          <p style="margin: 0px; font-size: 14px">{{ impressao.nomeMae }}</p>
          <p style="margin: 0px; font-size: 14px">{{ impressao.telefoneMae }}</p>
        </v-col>
        <!--  -->
        <v-col cols="9">
          <p style="margin: 0px; font-weight: bold; font-size: 30px;">{{ impressao.nome }}</p>
        </v-col>
        <v-col cols="3" style="text-align: right">
          <p style="margin: 0px; font-size: 30px; font-weight: bold">{{ impressao.idade }}</p>
        </v-col>
        <v-col cols="12" style="padding: 0px">
          <p style="margin: 0px; font-size: 20px">{{ impressao.sobrenome }}</p>
        </v-col>
        <v-col cols="6" style="text-align: center">
          <p style="margin: 0px; font-size: 14px">{{ impressao.nomePai }}</p>
          <p style="margin: 0px; font-size: 14px">{{ impressao.telefonePai }}</p>
        </v-col>
        <v-col cols="6" style="text-align: center">
          <p style="margin: 0px; font-size: 14px">{{ impressao.nomeMae }}</p>
          <p style="margin: 0px; font-size: 14px">{{ impressao.telefoneMae }}</p>
        </v-col>
      </v-row>
    </v-container>

    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import { mapState } from 'vuex'
  import Snackbar from '../../componentes/snackbar.vue'
  import axios from 'axios'
  import PH from 'print-html-element'
  export default {
    name: 'Checkin',

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    components: { Snackbar, Loading, },

    data: function () {
      return {
        idIgreja: '6390de5538a3bc18300a2022',
        igreja: {},
        fullPage: true,
        isLoading: false,
        dialogoLeituraQRCode: false,
        dialogoImprimirNovamente: false,
        dialogoTipoLeitura: false,
        membroTurmaId: '',
        tipoLeitura: '',
        impressao: [],
      }
    },

    watch: {
      dialogoLeituraQRCode(val) {
        if (val == true) {
          if (this.tipoLeitura == 'LEITOR') {
            setTimeout(() => {
              document.getElementById('campoCaptura').focus()
            }, 100);
          }
        } else {
          this.membroTurmaId = ''
        }
      }
    },

    mounted: function () {
      this.$validator.localize('pt', this.dictionary)

      if (!sessionStorage.getItem('tipoLeitura')) {
        this.dialogoTipoLeitura = true
      } else {
        this.tipoLeitura = sessionStorage.getItem('tipoLeitura')
      }

      this.carregaDados()
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        try {
          const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
          if (response.data) {
            this.igreja = response.data
          }
        } catch (error) {
          this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO')
        } finally {
          this.isLoading = false
        }
      },

      async realizaCheckin() {
        this.isLoading = true
        let vm = this

        await axios.post(baseApiUrl + 'MembrosTurmas/checkin', {"membroTurmaId": this.membroTurmaId})
        .then(response => {
          if (response.data) {
            this.impressao = response.data
            this.dialogoLeituraQRCode = false
            
            if (!response.data.checkinAnterior) {
              this.imprimir()
            } else {
              this.dialogoImprimirNovamente = true
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          this.dialogoLeituraQRCode = false
          vm.$refs.chamaSnackbar.snack("#EF5350", error.response.data.error.message,"DESCULPE")
        })

        this.isLoading = false
      },

      imprimir() {
        setTimeout(() => {
          PH.printElement(document.getElementById('printInscricao'))
        }, 100);
      },

      configuraTipoLeitura(tipo) {
        this.tipoLeitura = tipo
        sessionStorage.setItem('tipoLeitura', tipo)
        this.dialogoTipoLeitura = false
      },

      focaCampo() {
        setTimeout(() => {
          document.getElementById('campoCaptura').focus()
        }, 100);
      },

      fazerLeituraQRCode(decodedString) {
        this.membroTurmaId = decodedString
        this.realizaCheckin()
      }
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #5BC1A3, #01B094);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>
